import React from 'react';
import _sortBy from "lodash/sortBy";
import _get from "lodash/get";
import _findIndex from "lodash/findIndex";

import { dealershipFacetName, expandedPanels, hiddenPanels, inStockFacetName, priceItems } from "../../constants/algolia";

import CustomRangeInput from "../ContentBlocks/Cars/AlgoliaInputMenu";
import AlgoliaFiltersDesktop from "../ContentBlocks/Cars/AlgoliaFiltersDesktop";
import StockRangeInput from "../ContentBlocks/Cars/AlgoliaStockMenu";
import AvailabilityInput from "../ContentBlocks/Cars/AlgoliaAvailabilityMenu";
import extractFilterName from "../../helpers/extractFilterName";

// Custom order for model filters
const modelCustomOrder = [
    "XC40",
    "XC60",
    "XC90",
    "New XC60",
    "New XC90",
    "EX30",
    "EX40",
    "EX90",
    "EC40",
    "S60",
    "S90",
    "V60",
    "V90CC"
];

// Function to sort models according to custom order
const sortModelsByCustomOrder = (items) => {
    return [...items].sort((a, b) => {
        const indexA = _findIndex(modelCustomOrder, model => model === a.label);
        const indexB = _findIndex(modelCustomOrder, model => model === b.label);

        // If both models are in the custom order list
        if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
        }

        // If only model A is in the custom order list
        if (indexA !== -1) {
            return -1;
        }

        // If only model B is in the custom order list
        if (indexB !== -1) {
            return 1;
        }

        // If neither model is in the custom order list, sort alphabetically
        // This ensures any new models not in the custom order list will be at the bottom
        return a.label.localeCompare(b.label);
    });
};

const RenderCarFilters = (props) => {
    const { facets, isDealerPage } = props;
    const isMobileFilter = _get(props, 'isMobileFilter', false);

    if (facets.length !== 0) {
        return (
            facets.map((item, index) => {
                if (hiddenPanels.includes(item)) return null;
                /**
                 * Using custom numeric input filtering for prices
                 * TODO: Not anymore!
                 * TODO: CLEANUP! It's only added in hiddenPanels
                 */
                if (item === "client_invoice_price") return null;/* <CustomRangeInput
                    key={`${index}${item}`}
                    attribute='client_invoice_price'
                    expanded={expandedPanels.includes("client_invoice_price")}
                    staticPriceRanges={priceItems}
                />*/
                /**
                 * Custom stripped-down (and hidden) inputs for availability
                 */
                if (item === inStockFacetName) return <StockRangeInput
                    key={`${index}${item}`}
                    attribute={inStockFacetName}
                    expanded={true}
                />
                /**
                 * Using custom predefined ranges for availability
                 */
                if (item === "arrival_date_segment") return <AvailabilityInput
                    key={`${index}${item}`}
                    attribute='arrival_date_segment'
                    expanded={expandedPanels.includes("arrival_date_segment")}
                />
                /**
                 * Dealership expanded on mobile only
                 */
                // Check if the current filter is the model filter
                const isModelFilter = extractFilterName(item) === "model";

                return (
                    <AlgoliaFiltersDesktop
                        expanded={expandedPanels.includes(extractFilterName(item)) || (dealershipFacetName === extractFilterName(item) && isMobileFilter)}
                        key={`${index}${item}`}
                        attribute={item}
                        transformItems={items =>
                            isModelFilter
                                ? sortModelsByCustomOrder(items) // Use custom order for models
                                : _sortBy(items, 'label') // Use alphabetical order for other filters
                        }
                        isDealerPage={isDealerPage}
                        showMore={true}
                    />
                )
            })
        )
    }

    return null;
};

export default RenderCarFilters
